import { useContext } from 'react'
import { LOCAL_STORAGE_THEME_KEY, Theme, ThemeContext } from './theme-context'

interface UseThemeResult {
    theme: Theme
    toggleTheme: (theme: Theme) => void
}

export function useTheme(): UseThemeResult {
    const { theme, setTheme } = useContext(ThemeContext)

    const toggleTheme = (newTheme: Theme) => {
        setTheme?.(newTheme)
        localStorage.setItem(LOCAL_STORAGE_THEME_KEY, newTheme)
    }

    return { theme: theme || Theme.LIGHT, toggleTheme }
}
